export default __webpack_public_path__ + "static/media/united-states-svgrepo-com.65b9fb1a.svg";